import { defineComponent as _defineComponent } from 'vue'
import { CtProduct } from '@/models/interfaces/content-type'
import { ContentType } from '@/services/directr'
import { reactive } from 'vue'
import { useStore } from 'vuex'


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductSearchModal',
  props: {
    show: { type: Boolean, default: false }
  },
  emits: ["update:show", "select"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

const $store = useStore()
const directr = $store.getters['Services/Directr']

const props = __props

  const emit = __emit

const search = reactive({
  contentType: ContentType.Product,
  model: $store.getters['Products/Model'],
  config: { requests: { limit: 100 } },
  limit: 1
})

function emitSearchResult ({ selection }) {
  emit('update:show', false)
  emit('select', selection)
}

const __returned__ = { $store, directr, props, emit, search, emitSearchResult, get CtProduct() { return CtProduct }, get ContentType() { return ContentType }, reactive, get useStore() { return useStore } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})